import { render, staticRenderFns } from "./V2ImagesSection.vue?vue&type=template&id=39a5610b&scoped=true&"
import script from "./V2ImagesSection.vue?vue&type=script&lang=js&"
export * from "./V2ImagesSection.vue?vue&type=script&lang=js&"
import style0 from "./V2ImagesSection.vue?vue&type=style&index=0&id=39a5610b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a5610b",
  null
  
)

export default component.exports